<template>
  <BaseTable
      :title="$t('library_file')"
      :subtractHeight="subtractHeight"
      :height="height"
      dto-model="LibraryFileListQueryDTO"
      dto-save-list-model="LibraryFileSaveListCommandDTO"
      store-name="LibraryFileTable"
      new-item-component="LibraryFileItem"
      new-item-pass="/LibraryDoc/LibraryFile/LibraryFileItem"
      :lang-dictionary="function(text) {return $t(text)}"
      hide-default-footer
      fixed-header
  >
    <template v-slot:item.name="{ item }">
      <a :href="item.file_link" target="_blank">
        <span v-if="item.name">{{ item.name }}</span>
        <span v-else>****</span>
      </a>
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";

export default {
  name: 'LibraryFileTable',
  props: {
    subtractHeight: {type: [Number], default: 80},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false}
  },

  components: {
    BaseTable,
    BaseDeleteIcon,
  },

  computed: {},

  methods: {},

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {}
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n>
{
  "en": {
    "search": "Search",
    "No data available": "No data available",
    "deleted": "Deleted",
    "library_file": "Library files",
    "columns": {
      "drag": " ",
      "deleted": " ",
      "edit": " ",
      "uid": "UUID",
      "name": "Name",
      "created_by": "Created by",
      "edited_by": "Edited by",
      "created_by_name": "Created by",
      "edited_by_name": "Edited by",
      "created_on": "Created on",
      "edited_on": "Edited on"
    },
    "Save": "Save",
    "Cancel": "Cancel",
    "New item": "New item"
  },
  "de": {
    "search": "Suche",
    "No data available": "Keine Daten verfügbar",
    "deleted": "Gelöscht",
    "library_file": "Bibliotheksdateien",
    "columns": {
      "drag": " ",
      "deleted": " ",
      "edit": " ",
      "uid": "UUID",
      "name": "Name",
      "created_by": "Erstellt von",
      "edited_by": "Bearbeitet von",
      "created_by_name": "Erstellt von",
      "edited_by_name": "Bearbeitet von",
      "created_on": "Erstellt am",
      "edited_on": "Bearbeitet am"
    },
    "Save": "Speichern",
    "Cancel": "Stornieren",
    "New item": "Neuer Artikel"
  }
}
</i18n>
